<template>
<!--  社区资料-->
  <div class="community">
    <HeadNav/>
<!--    <ListEmpty />-->
    <div class="message">
      <h3>{{langUtil(67)}}</h3>
      <div class="img">
        <img src="../assets/img/img28.png">
      </div>
      <p>{{langUtil(126)}}
         <br/>{{langUtil(141)}}
        <br/>{{langUtil(142)}}
        <br/>{{langUtil(143)}}
        <br/>{{langUtil(144)}}
      </p>
      <div class="message_submit" v-on:click="$attrs.backUrl ? $router.push($attrs.backUrl) : $router.go(-1)">
        <van-button class="but b1">{{langUtil(69)}}</van-button>
        <van-button class="but b2">{{langUtil(115)}}</van-button>
      </div>

    </div>
  </div>
</template>

<script>
  import HeadNav from "../components/HeadNav";
  import ListEmpty from "../components/ListEmpty";

  export default {
    name: "community",
    components: {
      HeadNav,
      ListEmpty
    },
  }
</script>

<style lang="less" scoped>
  .empty{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding-top: 30%;

  }
  .d2{
    font-size: 12px;
    color: black;
  }
  .d3{
    width: 364px;
    height: 364px;
  }
  .message{
    padding: 20px;
    h3{
      text-align: center;
      margin-bottom: 20px;
    }
    .img{text-align: center;margin-bottom: 20px;}
    p{line-height: 1.7;color: #333;margin-bottom: 30px;}
  }
  .message_submit{
      display: flex;
      justify-content: space-between;
      .but{width: 48%;}
      .b1{}
      .b2{
        background: #B9EC54;
      }
  }

</style>
